import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment } from "@angular/router";
import { PublicCookieHelper } from "../helpers/public-cookie.helper";
import { OidcSecurityService } from "../services/oidc-security.service";
import { Settings } from "../settings/settings";

@Injectable()
export class AutoLoginGuard  {
  constructor(private oidcSecurityService: OidcSecurityService) {}


  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    return this.checkAuth();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>  {
    return this.checkAuth();
  }

  async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>  {
    return this.checkAuth();
  }
  
  private async checkAuth(): Promise<boolean> {
    let publicCookie = PublicCookieHelper.get();

    if(!PublicCookieHelper.isValid(publicCookie)
     || new Date().getTime() > PublicCookieHelper.getExpirationMinusSafetyTime(publicCookie, Settings.SilentRenew.TimeoutInSeconds.safetyTime))
    {
     publicCookie = await this.oidcSecurityService.tokenStatus().toPromise();
     PublicCookieHelper.create(publicCookie);
     if(!publicCookie.isAuthenticated){
        this.oidcSecurityService.authorize();
     }
    }

    return publicCookie.isAuthenticated;
  }
}
